var $b1c43225af597ba8$exports = {};
// Wait for fonts to load before starting animation
document.fonts.ready.then(()=>{
    const emojis = [
        "\u25C6",
        "\u25A0",
        "\u25B2",
        "\u25CF",
        "\u2605",
        "\u25BA",
        "\u25BC",
        "\u25C4",
        "\u25C8",
        "\u25AA",
        "\u25CA",
        "\u25CB",
        "\u25A1",
        "\u25B3",
        "\u25C7",
        "\u25EF",
        "\u25AB",
        "\u25B9"
    ];
    const scrambleElements = document.querySelectorAll(".scramble-text");
    scrambleElements.forEach((element)=>{
        // Store original text before any manipulation
        const originalText = element.textContent;
        // Only proceed if element has content
        if (!originalText) return;
        const letters = originalText.split("");
        const lettersHTML = letters.map((letter)=>{
            if (letter === " ") return " ";
            return `<span class="scramble-letter">${letter}</span>`;
        }).join("");
        element.innerHTML = lettersHTML;
        // Initial animation on page load
        const letterElements = element.querySelectorAll(".scramble-letter");
        let animationDuration = 300;
        let startTime = Date.now();
        const initialAnimation = setInterval(()=>{
            const elapsed = Date.now() - startTime;
            if (elapsed < animationDuration) letterElements.forEach((letterElement)=>{
                const originalLetter = letterElement.dataset.original || letterElement.textContent;
                letterElement.dataset.original = originalLetter;
                if (Math.random() > elapsed / animationDuration) letterElement.textContent = emojis[Math.floor(Math.random() * emojis.length)];
                else letterElement.textContent = originalLetter;
            });
            else {
                clearInterval(initialAnimation);
                letterElements.forEach((letterElement)=>{
                    letterElement.textContent = letterElement.dataset.original;
                });
            }
        }, 50);
        // Regular hover effect
        letterElements.forEach((letterElement)=>{
            const originalLetter = letterElement.textContent;
            letterElement.addEventListener("mouseenter", ()=>{
                const randomSymbol = emojis[Math.floor(Math.random() * emojis.length)];
                letterElement.textContent = randomSymbol;
            });
            letterElement.addEventListener("mouseleave", ()=>{
                letterElement.textContent = originalLetter;
            });
        });
    });
});


//# sourceMappingURL=about.b5d6651c.js.map
